import React from 'react';
import styled from 'styled-components';
import logo from '../../assets/logo01.png';
//import Burger from '../../components/Burger/Burger';

import './Topbar.css';

const Logo = styled.img`
  display: flex;
  position: absolute;
  justify-content: flex-start;
  height: 90%;
  margin-left:45px;

`;



const toolbar = props => (
	<header className = "toolbar">
	  <nav className = "toolbar__navigation">
	    <div>
	 
	    </div>
        <Logo src= {logo}/>
	  </nav>
	</header>
	);

export default toolbar;